import React from "react";

export const Spacer = ({ size, backgroundColor = "" }) => (
  <div className={`h-0 h-lg-${size}rem ${backgroundColor}`} />
);
